module.exports = __webpack_public_path__ + "static/media/DPILogo_Horizontal_Charcoal_RGB.84e23b92.svg";